/* eslint-disable padding-line-between-statements */
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useTranslator, IntlContext} from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import TWIADateFormatUtil from "ent-capability-quoteandbind-common-react/util/TWIADateFormatUtil";
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, { useCallback, useContext, useState } from 'react';
import { Loader, useModal } from '@jutro/components';
import CustomLoader from 'producer-engage/src/components/CustomLoader/CustomLoader';
// import PrintDocumentUtil from 'ent-capability-quoteandbind-common-react/util/PrintDocumentUtil.js';
import { CustomQuoteService } from 'twia-capability-quoteandbind-residential';
import PrintDocumentUtils from 'ent-capability-quoteandbind-common-react/util/PrintDocumentUtils.js';
import PrintDocumentConfirmationPopup from 'ent-capability-quoteandbind-common-react/pages/PrintDocument/PrintDocumentConfirmationPopup';
import PrintDocumentErrorPopup from 'ent-capability-quoteandbind-common-react/pages/PrintDocument/PrintDocumentErrorPopup';


import { PolicyDiffComponent } from "gw-capability-policyjob-react/index.js";
import UWUtil from 'ent-capability-quoteandbind-common-react/util/UWUtil';
import UnderwritingWarningComponent from 'ent-capability-quoteandbind-common-react/components/UnderwritingWarningComponent/UnderwritingWarningComponent';
import metadata from './QuoteAndReviewPage.metadata.json5';
import styles from './QuoteAndReviewPage.module.scss'

function QuoteAndReviewPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { wizardData: submissionVM, updateWizardData, jumpTo, onResolve, onAfterClose } = props;
    const { authHeader } = useAuthentication();
    const { showAlert, showConfirm, showModal } = useModal();
    const jobID = _.get(submissionVM, 'jobID.value');
    const intlContext = useContext(IntlContext);
    const translator = useTranslator();
    const periodEndDate = _.get(submissionVM, `baseData.periodEndDate.value`);
    const periodStartDate = _.get(submissionVM, `baseData.periodStartDate.value`);
    const changeInCost = _.get(submissionVM, 'transactionCost.value');
    const increase = changeInCost?.amount > 0;
    const [isLoading, setIsLoading] = useState(false);
    const [isPrinting, setIsPrinting] = useState(false);


    // const quotePrintDocument = useCallback(async () => {
    //     setIsPrinting(true);
    //     await PrintDocumentUtil.printDocument(submissionVM, showConfirm, showAlert, translator, authHeader, setIsPrinting);
    // }, [authHeader, showAlert, showConfirm, submissionVM, translator])

    const quotePrintDocument = useCallback(() => {
        const {getPublicID, getPath, getQuoteStatus} = PrintDocumentUtils(submissionVM);
        setIsPrinting(true);
        
        const publicID = getPublicID();
        const docPath = getPath();
        const quoteStatus = getQuoteStatus();       
        const componentProps = { submissionVM, setIsPrinting, isOpen: true, onResolve, onAfterClose, docPath, quoteStatus};       
        if (quoteStatus === 'Quoted' || quoteStatus === 'Submitted_Ext' || quoteStatus === 'Renewing') {
            CustomQuoteService.generateDocument_TWIA(publicID, 'quoteSummary', authHeader).then(() => {
                showModal(<PrintDocumentConfirmationPopup {...componentProps} />);
            });
        }  else {
            showModal(<PrintDocumentErrorPopup {...componentProps} />);
        }
    }, [authHeader, onAfterClose, onResolve, showModal, submissionVM])

    const formatPolicyPeriod = (startDate, endDate) => {
        const formattedStartDate = TWIADateFormatUtil.formatDate(startDate);
        const formattedEndDate = TWIADateFormatUtil.formatDate(endDate);

        return `${formattedStartDate} - ${formattedEndDate}`;
    };

    const onEditCoverage = useCallback(() => {
        jumpTo(2);
    }, [jumpTo]);

    const showUWWarningComponent = useCallback(() => {
        if (_.get(submissionVM, 'errorsAndWarnings.underwritingIssues.value') !== undefined) {
            return UWUtil.checkUWIssues(_.get(submissionVM, 'errorsAndWarnings.underwritingIssues.value'))
        }

        return false
    }, [submissionVM])

    const diffCost = useCallback(() => {
        const formattedDiffCost = intlContext.formatNumber(changeInCost?.amount, {
            style: 'currency',
            currency: changeInCost?.currency
        });

        if(increase){
            return `+${formattedDiffCost}`;
        }

        return formattedDiffCost;
    }, [changeInCost, increase, intlContext]);

    const overrideProps = {
        '@field': {
            // apply to all fields
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        quoteHeaderSection: {
            visible: !showUWWarningComponent() // DE17846
        },
        premiumLayout: {
            visible: !showUWWarningComponent()
        },
        diffBr: {
            visible: !showUWWarningComponent()
        },
        proposedPolicyPeriod: {
            value: formatPolicyPeriod(periodStartDate, periodEndDate)
        },
        premiumDifference: {
            value: diffCost()
        },
        policyDiffComponent:{
            value: jobID,
            visible: !showUWWarningComponent()
        },
        UnderwritingWarning: {
            submissionVM,
            visible: showUWWarningComponent()
        },
        quotePagePrint: {
            visible : !isPrinting
        },
        cLoader: {
            visible: isPrinting
        }
    };

    const resolvers = {
        resolveComponentMap: {
            PolicyDiffComponent,
            UnderwritingWarningComponent,
            customLoader: CustomLoader
        },
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            quotePrintDocument,
            onEditCoverage
           
        },
    };

    return (
        <WizardPage
            // onNext={onNext}
            disableNext={showUWWarningComponent()}
        >
            <Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={submissionVM}
                    overrideProps={overrideProps}
                    onModelChange={updateWizardData}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
            </Loader>
        </WizardPage>
    );
}

QuoteAndReviewPage.propTypes = wizardProps;
export default QuoteAndReviewPage;